import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PropertySearchWidgetLocation } from '@app/modules/direct/services/direct.service';
import { Subject } from 'rxjs';

@Component({
  standalone: false,
  selector: 'sbnb-direct-location-editor-item',
  templateUrl: './direct-location-editor-item.component.html',
  styleUrls: ['./direct-location-editor-item.component.scss'],
})
export class DirectLocationEditorItemComponent implements OnInit {
  @Input('onDrop') public onDragDrop$!: Subject<CdkDragDrop<Array<PropertySearchWidgetLocation>>>;
  @Input() item!: PropertySearchWidgetLocation;
  @Input() invert!: boolean;
  @Input() level: number;

  @Output() itemAdded = new EventEmitter<PropertySearchWidgetLocation>();
  @Output() itemDeleted = new EventEmitter<PropertySearchWidgetLocation>();
  @Output() itemEdited = new EventEmitter<PropertySearchWidgetLocation>();

  constructor() { }

  ngOnInit() { }

  addSublocation(intendedParent: PropertySearchWidgetLocation) {
    this.itemAdded.emit(intendedParent);
  }

  removeLocation(item: PropertySearchWidgetLocation) {
    this.itemDeleted.emit(item);
  }

  editLocation(item: PropertySearchWidgetLocation) {
    this.itemEdited.emit(item);
  }
}
